module.exports = __webpack_public_path__ + "static/img/logo_big.15b08854.svg";